import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {SteelProfile, FrameProfile, PurlinProfile, EaveStrutProfile} from '../steel-profile';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {SteelProfileService} from '../steel-profile.service';

@Component({
    selector: 'app-steel-profile-create',
    templateUrl: './steel-profile-create.component.html',
    styleUrls: ['./steel-profile-create.component.css']
})
export class SteelProfileCreateComponent implements OnInit {
    newProfile: SteelProfile;
    profileTypeForm: AbstractControl;
    @Input() profileTypes;
    @Output() updateListProfiles = new EventEmitter();
    @Output() createProfileType = new EventEmitter();

    formValidities = {
        'common': false,
        'specific': false
    };

    constructor(private fb: FormBuilder,
                private router: Router,
                private profileService: SteelProfileService) {
        this.profileTypeForm = this.fb.group({
            profile_type: ['', [Validators.required]]
        });
    }

    ngOnInit() {
        this.profileTypeForm.valueChanges.subscribe(values => this.initProfile(values));
    }

    initProfile(values) {
        var index = -1;
        for(var i = 0; i < this.profileTypes.length; i++){
          if(this.profileTypes[i].value == values.profile_type){
            index = i;
            break;
          }
        }
        if(index >= 0){
          this.newProfile = SteelProfile.getProfileByFamily(this.profileTypes[index].family);
          this.newProfile.profile_type = values.profile_type;
          this.newProfile.type_name = this.profileTypes[index].name;
        }
    }

    cancelCreation() {
        // this.router.navigate(['/perfiles']);
        this.profileTypeForm.reset();
        this.newProfile = null;
    }

    create() {
        this.profileService.create(this.newProfile).subscribe(
            (res) => {
              // this.router.navigate(['/perfiles']);
              this.updateListProfiles.emit();
              this.cancelCreation();
            }
        );
    }

    clickShowFormProfileType(){
      this.createProfileType.emit();
    }

    onCommonIsValid(valid: boolean) {
        this.formValidities.common = valid;
    }

    onSpecificIsValid(valid: boolean) {
        this.formValidities.specific = valid;
    }

    canCreate(): boolean {
        return this.formValidities.common && this.formValidities.specific;
    }
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-create/steel-profile-create.component.ts